import React from 'react';
import { useTranslation } from 'react-i18next';

import { Link } from './Link';
import { OnboardingProgressIndicator } from './OnboardingProgressIndicator';

export interface OnboardingNavbarProps {
  numberOfCompletedSteps: number;
  totalSteps: number;
  title?: string;
  backButtonHref?: string;
}

export const OnboardingNavbar: React.FC<OnboardingNavbarProps> = ({
  title,
  backButtonHref,
  numberOfCompletedSteps,
  totalSteps,
}) => {
  const __ = useTranslation().t;
  const BackButton = () =>
    backButtonHref ? (
      <Link icon="arrow-left" variant="black-main" href={backButtonHref} italic={false}>
        {__('back')}
      </Link>
    ) : (
      <span />
    );

  return (
    <div className="oejr-onboarding-navbar">
      <div className="oejr-onboarding-navbar-row-1">
        <BackButton />
        {title && <h4 className="d-none d-md-block">{title}</h4>}
        <OnboardingProgressIndicator
          total={totalSteps}
          numberOfCompleted={numberOfCompletedSteps}
        />
      </div>
      {title && (
        <div className="oejr-onboarding-navbar-row-2 d-block d-md-none">
          <h4>{title}</h4>
        </div>
      )}
    </div>
  );
};
